module.exports = __webpack_public_path__ + "static/media/STHiFi1.47582e33.png";